import { CEFR_EQUIVALENCES, CEFR_LEVELS } from '@repo/config';
import type { IEnglishIqResult } from '@repo/sdk';
import type { EnglishIqMessagesType } from '../english-iq-messages-type';
import { EnglishIqScoreGauge } from './english-iq-score-gauge';

interface IEnglishIqScoreSummaryProps {
  disclaimer: string;
  messages: EnglishIqMessagesType['result'];
  result: IEnglishIqResult;
}

export function EnglishIqScoreSummary({
  disclaimer,
  messages,
  result,
}: IEnglishIqScoreSummaryProps): React.JSX.Element {
  const cefr = CEFR_LEVELS.find((level) => level === result.cefr);
  const equivalence = cefr ? CEFR_EQUIVALENCES[cefr] : null;
  return (
    <>
      <EnglishIqScoreGauge cefr={result.cefr} score={result.score} />
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <span className="rounded-full bg-foreground px-5 py-2.5 font-semibold text-background">
          {messages.cefr.replace('{cefr}', result.cefr)}
        </span>
        {equivalence ? (
          <>
            <span className="rounded-full border border-foreground/15 bg-card px-5 py-2.5 font-medium">
              {messages.ielts.replace('{score}', equivalence.ielts)}
            </span>
            <span className="rounded-full border border-foreground/15 bg-card px-5 py-2.5 font-medium">
              {messages.toefl.replace('{score}', equivalence.toefl)}
            </span>
          </>
        ) : null}
      </div>
      {result.weakestFamilies.length > 0 ? (
        <div className="mt-9">
          <p className="text-sm font-semibold text-muted-foreground">{messages.weakest}</p>
          <div className="mt-3 flex flex-wrap justify-center gap-2">
            {result.weakestFamilies.map((family) => (
              <span
                key={family}
                className="rounded-xl bg-violet-500/10 px-4 py-2 text-sm font-medium"
              >
                {family}
              </span>
            ))}
          </div>
        </div>
      ) : null}
      <p className="mx-auto mt-8 max-w-xl text-xs leading-5 text-muted-foreground">{disclaimer}</p>
    </>
  );
}
